import React from "react";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import { DataTable, Button, Can, PdfShiftReport } from "../../../../";
import { pdf } from "@react-pdf/renderer";
import FileSaver from "file-saver";
var useStyles = makeStyles(function (theme) {
  return {
    box: {
      display: "flex",
      "align-items": "center",
      "border-radius": "4px",
      border: "1px solid #7d7d7d"
    },
    titleCard: {
      textAlign: "center",
      width: "100%",
      margin: "16px 0"
    },
    actionsTitle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    mt50: {
      marginTop: "50px"
    }
  };
});

var WebStaffList = function WebStaffList(props) {
  var classes = useStyles();

  var handleDownloadShiftReport = function handleDownloadShiftReport() {
    props.data.handleDownloadShiftReport().then(function (data) {
      var document = /*#__PURE__*/React.createElement(PdfShiftReport, {
        data: data
      });
      return pdf(document).toBlob().then(function (blob) {
        return FileSaver.saveAs(blob, "reporte.pdf");
      });
    });
  };

  return /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 10
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2"
  }, props.translation ? props.translation.title : "Staff")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 2,
    className: classes.actionsTitle
  }, /*#__PURE__*/React.createElement(Can, {
    role: props.role,
    perform: "staff:download_shift_report",
    yes: function yes() {
      return /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        fullWidth: true,
        onClick: handleDownloadShiftReport
      }, props.translation ? props.translation.buttons ? props.translation.buttons.download_shift_report : "Download shift report" : "Download shift report");
    },
    no: function no() {
      return null;
    }
  }))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.mt50
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.mt50
  }, /*#__PURE__*/React.createElement(DataTable, {
    data: props.data ? props.data.staff || [] : [],
    translation: props.translation ? props.translation.datatables ? props.translation.datatables.staff || null : null : null
  }))));
};

export { WebStaffList };